export default "__VITE_ASSET__B4M8wF7k__"